import { render, staticRenderFns } from "./peda.vue?vue&type=template&id=e68d1f6e&"
import script from "./peda.vue?vue&type=script&lang=js&"
export * from "./peda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports